import { Plugin } from 'prosemirror-state'

import { PRIORITY_EDITOR } from 'proseShared/constants'

// This plugin handles situations like comments/tasks/link modals with prosemirror instances of their own (ProseInput) or not
// That are leaking keyboard events because they are failing to focus or taking too long to focus or intermittently doing either
// These events are supposed to the handled at the offending component but by their erratic nature that is hard and brittle
// The fact that those components are supposed to hold focus and handle all keypress events gives us the possibility to check
//   the dom for their presence and ignore the events
// That is what we do here
export const stopErroneousKeyPropagation = new Plugin({
  props: {
    handleKeyDown: (_view, event) => {
      // The focus is sometimes not properly set on the element the user is supposed to be editing
      // But letting keyevents propagate has the uncanny effect of deleting the selection while the comment/task prompt is open
      // This is an intermittent problem and this is a last line of defence
      // tldr; PRIORITY_EDITOR fails to focus -> event.currentTarget === event.target && event.target === Article PM
      const priorityFocusElements = document.getElementsByClassName(PRIORITY_EDITOR)
      if (priorityFocusElements.length) {
        // eslint-disable-next-line no-console
        console.error(
          `The following elements are either: failing to focus, leaking keyboard events up the tree, or supposed to be removed:`,
          ...priorityFocusElements,
        )
        return true
      }
      return false
    },
  },
})
